import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/auth/ProtectedRoute';
import VendorProtectedRoute from './components/auth/VendorProtectedRoute';
import VendorLogin from './pages/vendor/VendorLogin';
import VendorLayout from './pages/vendor/VendorLayout';
import VendorDevices from './pages/vendor/VendorDevices';
import VendorDeviceDetail from './pages/vendor/VendorDeviceDetail';
import ErrorBoundary from './components/ErrorBoundary';
import NetworkErrorBoundary from './components/NetworkErrorBoundary';
import { Toaster } from 'react-hot-toast';
import DocumentTitle from './components/DocumentTitle';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <WebSocketProvider>
            <NetworkErrorBoundary>
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                  success: {
                    style: {
                      background: '#10b981',
                    },
                  },
                  error: {
                    style: {
                      background: '#ef4444',
                    },
                  },
                }}
              />
              <DocumentTitle />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/dashboard/*"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                {/* Vendor (dealer/manufacturer) read-only area */}
                <Route path="/vendor-login" element={<VendorLogin />} />
                <Route
                  path="/vendor"
                  element={
                    <VendorProtectedRoute>
                      <VendorLayout>
                        <VendorDevices />
                      </VendorLayout>
                    </VendorProtectedRoute>
                  }
                />
                <Route
                  path="/vendor/devices/:serial"
                  element={
                    <VendorProtectedRoute>
                      <VendorLayout>
                        <VendorDeviceDetail />
                      </VendorLayout>
                    </VendorProtectedRoute>
                  }
                />
                <Route path="/" element={<Navigate to="/dashboard" />} />
              </Routes>
            </NetworkErrorBoundary>
          </WebSocketProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;